import React, {
    useMemo, useState, useEffect, useCallback,
} from 'react';
import AsyncSelect from 'react-select/async';
import { axiosInstance, convertFilterFormat } from '@appblocks/frontend/client/utils';
import debounce from 'lodash/debounce';
import { useSelector } from 'react-redux';

const ModelSelect = ({
    model,
    isMulti,
    onChange,
    value,
    filters,
    apiRoute,
    nameProperty,
    ...props
}) => {
    const [options, setOptions] = useState([]);
    const [selectValue, setSelectedValue] = useState(null);
    const workspace = useSelector(state => state.workspaces.currentWorkspace);

    let route = '';
    if (apiRoute) {
        route = apiRoute;
    } else {
        switch (model) {
            case 'projects':
            case 'workspaces':
                route = `/api/${model}`;
                break;
            default:
                route = `/cgg/${model}`;
        }
    }

    useEffect(() => {
        if (isMulti) {
            const prevSelectValue = selectValue || [];
            const selectValueSet = new Map();
            options.concat(prevSelectValue).forEach((option) => {
                const key = option._id;
                if (!selectValueSet.has(key)) {
                    selectValueSet.set(key, option);
                }
            });
            const selectValueArray = Array.from(selectValueSet.values());
            setSelectedValue(value.map(option => selectValueArray.find(o => o._id === option)));
            return;
        }
        setSelectedValue(options.find(option => option._id === value) ?? null);
    }, [value, options, isMulti]);

    const debouncedLoadOptions = useMemo(() => debounce((inputValue, callback) => {
        let parsedFilters = {};
        if (filters) {
            parsedFilters = convertFilterFormat(filters);
        }
        const params = {
            search: inputValue,
            start: 0,
            count: 50,
            workspace,
            ...parsedFilters,
        };
        axiosInstance.get(`${process.env.API_URL}${route}`, {
            params,
        })
            .then((response) => {
                if (!response.data.data || !Array.isArray(response.data.data)) {
                    throw new Error();
                }
                setOptions(response.data.data);
                callback(response.data.data);
            })
            .catch((error) => {
                setOptions([]);
                callback([]);
            });
    }, 500), [route]);

    return (
        <AsyncSelect
            key={route}
            isMulti={isMulti}
            cacheOptions
            defaultOptions
            loadOptions={debouncedLoadOptions}
            onChange={(change) => {
                if (isMulti) {
                    onChange(change.map(option => option._id));
                } else {
                    onChange(change._id);
                }
            }}
            getOptionLabel={(option) => {
                return nameProperty ? option[nameProperty] : option.name;
            }}
            getOptionValue={option => option._id}
            styles={{
                menuPortal: provided => ({ ...provided, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
            value={selectValue}
            id={`model-select-${model}`}
            {...props}
        />
    );
};

export default ModelSelect;
